/* eslint-disable @typescript-eslint/no-non-null-assertion */
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor(private readonly http: HttpClient) {}

  getAGLHolidayList(): Observable<any> {
    const url = environment.OASUrl() + '/Holiday/GetHolidayList';
    const res = this.http.get(url, {
      headers: new HttpHeaders(environment.requestKeysAPP),
      responseType: 'json',
    });
    return res.pipe(
      map((data: any) => {
        return data;
      }),
    );
  }
}
